export default {"src":"/_next/static/media/coinWithChart_40.c9b9c361.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};